/**
 * INSS employee contribution progressive table constants.
 * @see https://www.gov.br/inss/pt-br/noticias/confira-como-ficaram-as-aliquotas-de-contribuicao-ao-inss
 */

export const INSS_PORTARIA_DOU_URL =
  'https://www.in.gov.br/web/dou/-/portaria-interministerial-mps/mf-n-6-de-10-de-janeiro-de-2025-606526848';

export const INSS_PORTARIA_PDF_URL =
  'https://www.gov.br/previdencia/pt-br/assuntos/rpps/legislacao-dos-rpps/2025/PortariaInterministerialMPSMFn6de10jan2025.pdf';

export const INSS_ALIQUOTAS_URL =
  'https://www.gov.br/inss/pt-br/noticias/confira-como-ficaram-as-aliquotas-de-contribuicao-ao-inss';

export const LEI_10887_URL = 'https://www.planalto.gov.br/ccivil_03/_ato2004-2006/2004/lei/l10887.htm';

export const INSS_DEFAULT_ANO = 2025;

export const INSS_FAIXAS_POR_TABELA = 4;

export const INSS_TETO_2025 = 8157.41;

/** Golden salary R$ 3.000,00 — faixa 3, contribuição R$ 253,41. */
export const INSS_GOLDEN_SALARIO_3000 = 3000;

export const INSS_GOLDEN_CONTRIBUICAO_3000 = 253.41;
